import { render, staticRenderFns } from "./ManageReportCategories.vue?vue&type=template&id=54212666&scoped=true"
import script from "./ManageReportCategories.vue?vue&type=script&lang=js"
export * from "./ManageReportCategories.vue?vue&type=script&lang=js"
import style0 from "./ManageReportCategories.vue?vue&type=style&index=0&id=54212666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54212666",
  null
  
)

export default component.exports